import React, { useState, useEffect } from 'react';
import styles from '../styles/TimePicker.module.css';

const TimePicker = ({ value, onChange, name, required }) => {
  const [hour, setHour] = useState('');
  const [minute, setMinute] = useState('');
  const [period, setPeriod] = useState('AM');

  // Parse existing value (HH:MM format) into hour, minute, period
  useEffect(() => {
    if (value && value.includes(':')) {
      const [h, m] = value.split(':').map(Number);
      if (!isNaN(h) && !isNaN(m)) {
        const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
        const period = h >= 12 ? 'PM' : 'AM';
        setHour(hour12.toString());
        setMinute(m.toString().padStart(2, '0'));
        setPeriod(period);
      }
    } else if (!value) {
      setHour('');
      setMinute('');
      setPeriod('AM');
    }
  }, [value]);

  // Convert 12-hour to 24-hour format
  const convertTo24Hour = (h, m, p) => {
    let hour24 = parseInt(h);
    if (p === 'PM' && hour24 !== 12) {
      hour24 += 12;
    } else if (p === 'AM' && hour24 === 12) {
      hour24 = 0;
    }
    return `${hour24.toString().padStart(2, '0')}:${m.padStart(2, '0')}`;
  };

  const handleHourChange = (e) => {
    const newHour = e.target.value;
    setHour(newHour);
    if (newHour && minute) {
      const time24 = convertTo24Hour(newHour, minute, period);
      onChange({ target: { name, value: time24 } });
    }
  };

  const handleMinuteChange = (e) => {
    const newMinute = e.target.value;
    setMinute(newMinute);
    if (hour && newMinute) {
      const time24 = convertTo24Hour(hour, newMinute, period);
      onChange({ target: { name, value: time24 } });
    }
  };

  const handlePeriodChange = (e) => {
    const newPeriod = e.target.value;
    setPeriod(newPeriod);
    if (hour && minute) {
      const time24 = convertTo24Hour(hour, minute, newPeriod);
      onChange({ target: { name, value: time24 } });
    }
  };

  return (
    <div className={styles.timePickerContainer}>
      <select
        value={hour}
        onChange={handleHourChange}
        className={styles.timeSelect}
        required={required}
      >
        <option value="">HH</option>
        {[...Array(12)].map((_, i) => {
          const h = i + 1;
          return <option key={h} value={h}>{h.toString().padStart(2, '0')}</option>;
        })}
      </select>
      
      <span className={styles.timeSeparator}>:</span>
      
      <select
        value={minute}
        onChange={handleMinuteChange}
        className={styles.timeSelect}
        required={required}
      >
        <option value="">MM</option>
        {[...Array(60)].map((_, i) => {
          const m = i.toString().padStart(2, '0');
          return <option key={m} value={m}>{m}</option>;
        })}
      </select>
      
      <select
        value={period}
        onChange={handlePeriodChange}
        className={styles.timePeriod}
        required={required}
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
};

export default TimePicker;
